// extracted by mini-css-extract-plugin
export default {"modal":"UserSurveyEPage_modal__EpeDb"};